import { httpClient, postProcessUpsert } from "@genai/http-client";
import { ApiCollection, CreateCollectionForm } from "../model";
import { toCollection } from "./toCollection";

export function createCollection(createCollectionForm: CreateCollectionForm) {
  return httpClient("/collections", {
    method: "POST",
    body: JSON.stringify(createCollectionForm),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(postProcessUpsert<ApiCollection>)
    .then(toCollection);
}